import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { Question } from 'src/app/models/question.model';
import { QuestionComponent } from '../question/question.component';
import { QuestionDisplayComponent } from '../question-display/question-display.component';
import { DragStore } from 'src/app/store/drag-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { QueueScheduler } from 'rxjs/internal/scheduler/QueueScheduler';
import { EQuestionType } from 'src/app/models/questionType.model';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { EImageStatus } from 'src/app/models/EnumImageStatus';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';

@Component({
    selector: 'que-warp-question',
    imports: [CommonModule,
        QuestionComponent,
        QuestionDisplayComponent,
        ReactiveFormsModule,
        FormsModule
    ],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: WarpQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: WarpQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './warp-question.component.html',
    styleUrls: ['./warp-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarpQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input()
  index?: number;
  @Output() deleteMeEvent = new EventEmitter();
  @Output() dupliacteQuestionEvent = new EventEmitter();

  question = new FormControl<Question | null>(null);
  #dragStore = inject(DragStore);
  #questionnaireApiService = inject(QuestionnaireApiService);
  #questionnaireStore = inject(QuestionnaireStore);
  focusId$ = toSignal(this.#dragStore.focusId$);
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any = () => { };

  questionSignal$ = toSignal(this.question.valueChanges)

  ngOnInit(): void {
    this.question.valueChanges.subscribe(q =>
      this.registerOnChangeCallback(q)
    )
  }

  writeValue(obj: Question): void {
    this.question.setValue(obj);
    if (obj.type.id == EQuestionType.Image) {
      if (!obj.imageBase64 && obj.statusImage == EImageStatus.Load) {
        this.#questionnaireApiService.getImageByQuestioneId(obj.id)
          .subscribe(image => {
            this.#questionnaireStore.addUnnecessaryChanges(true);
            this.question.setValue({ ...this.question.value, imageBase64: image.base64 , statusImage:EImageStatus.Saved } as Question);
          })
      }
    }
  }
  registerOnValidatorChange?(fn: any): void {
    this.onValidationChangeCallBack = fn;
  }
  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.question.valid) {
      return null;
    }
    return { 'warp-question': "not-valid" }
  }

}
